import { z } from 'zod';
// ─── Var Types ──────────────────────────────────────────────────────────────
export const appSettingVarTypeEnum = z.enum([
    'TEXT',
    'NUMBER',
    'DATE',
    'BOOLEAN',
    'USER',
    'VENDOR',
    'VENUE',
    'LIST',
]);
export const appSettingListItemTypeEnum = z.enum([
    'TEXT',
    'NUMBER',
    'DATE',
    'COLOR',
    'URL',
    'EMAIL',
    'USER',
    'VENDOR',
    'VENUE',
]);
// ─── App Settings ───────────────────────────────────────────────────────────
export const createAppSettingSchema = z.object({
    varCode: z.string().min(1).max(100),
    name: z.string().min(1).max(255),
    description: z.string().max(1000).optional(),
    varType: appSettingVarTypeEnum,
    value: z.string().max(10000).optional(),
    listCode: z.string().max(100).optional(),
    isActive: z.boolean().optional(),
    sortOrder: z.number().int().optional(),
});
export const updateAppSettingSchema = z.object({
    name: z.string().min(1).max(255).optional(),
    description: z.string().max(1000).nullable().optional(),
    varType: appSettingVarTypeEnum.optional(),
    value: z.string().max(10000).nullable().optional(),
    listCode: z.string().max(100).nullable().optional(),
    isActive: z.boolean().optional(),
    sortOrder: z.number().int().optional(),
});
// ─── App Setting Lists ──────────────────────────────────────────────────────
export const createAppSettingListSchema = z.object({
    listCode: z.string().min(1).max(100),
    name: z.string().min(1).max(255),
    description: z.string().max(1000).optional(),
    itemType: appSettingListItemTypeEnum,
    items: z.array(z.unknown()).optional(),
    isActive: z.boolean().optional(),
});
export const updateAppSettingListSchema = z.object({
    name: z.string().min(1).max(255).optional(),
    description: z.string().max(1000).nullable().optional(),
    itemType: appSettingListItemTypeEnum.optional(),
    items: z.array(z.unknown()).optional(),
    isActive: z.boolean().optional(),
});
// ─── Search ─────────────────────────────────────────────────────────────────
export const searchQuerySchema = z.object({
    type: z.enum(['user', 'vendor', 'venue', 'event']),
    q: z.string().min(1).max(255),
    limit: z.coerce.number().int().min(1).max(100).optional().default(20),
});
//# sourceMappingURL=app-settings.js.map